/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbMetiersLocalisationGridDtoPaginatedResults,
  FilterCriteriaInfo,
  MetierLocalisationSearch,
  SelectItem,
} from '../models/index';
import {
    FcbMetiersLocalisationGridDtoPaginatedResultsFromJSON,
    FcbMetiersLocalisationGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    MetierLocalisationSearchFromJSON,
    MetierLocalisationSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface MetierLocalisationBaseSearchRequest {
    MetierLocalisationSearch?: MetierLocalisationSearch;
}

export interface MetierLocalisationGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface MetierLocalisationGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class MetierLocalisationApi extends runtime.BaseAPI {

    /**
     */
    async metierLocalisationBaseSearchRaw(requestParameters: MetierLocalisationBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbMetiersLocalisationGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/MetierLocalisation/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetierLocalisationSearchToJSON(requestParameters.MetierLocalisationSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbMetiersLocalisationGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async metierLocalisationBaseSearch(requestParameters: MetierLocalisationBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbMetiersLocalisationGridDtoPaginatedResults> {
        const response = await this.metierLocalisationBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async metierLocalisationGetSearchCriteriasRaw(requestParameters: MetierLocalisationGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/MetierLocalisation/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async metierLocalisationGetSearchCriterias(requestParameters: MetierLocalisationGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.metierLocalisationGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async metierLocalisationGetSelectItemsRaw(requestParameters: MetierLocalisationGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling metierLocalisationGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/MetierLocalisation/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async metierLocalisationGetSelectItems(requestParameters: MetierLocalisationGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.metierLocalisationGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
